import script from "./BrandCreateForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandCreateForm.vue?vue&type=script&setup=true&lang=ts"

import "./BrandCreateForm.vue?vue&type=style&index=0&id=38991223&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38991223"]])

export default __exports__